import { render, staticRenderFns } from "./CadCliente.vue?vue&type=template&id=3bc912d4&"
import script from "./CadCliente.vue?vue&type=script&lang=js&"
export * from "./CadCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports